// Components==============
import Carousel from 'components/UI/Carousel/Carousel';
import React from 'react';
import './index.module.scss';
// ========================

const images = [
    '/images/hero-1.jpg',
    '/images/hero-2.jpg',
    '/images/hero-3.jpg',
];

export default function Hero() {
    return (
        <Carousel images={images}>
            <div styleName="content">
                <h1>Vind jouw volgende stap binnen onze samenwerking</h1>
                <p>Alle mogelijkheden voor je loopbaan op één plek.</p>
            </div>
        </Carousel>
    );
}
